module.exports = __webpack_public_path__ + "static/media/avatars_male_28.805cfaab.png";